import React from 'react';
import CallToActionOne from '../cta/CallToActionOne';
import SmallGalleryBabyComponent from '../galleries/SmallGalleryBabyComponent';
// Components

function BabyServicesPageMainContainer() {
  return (
    <main role='main' className='grid gap-y-12 w-full h-full pb-12'>
      {/* List of services */}
      <section className='grid w-full'>
        <div className='grid w-full px-6 lg:container lg:mx-auto gap-8 pt-12 bg-colour1/80 pb-4'>
          <ul className='grid gap-4 text-center pl-6'>
            <li>
              <strong>Naptime Discipline:</strong> Enforced naps, nappy diaper
              checks, pacifier time, and pre-nap punishments for naughty
              behavior.
            </li>
            <li>
              <strong>Nappy Diaper Domination:</strong> Nappy Diaper changes,
              humiliation, and full control—you're Nanny’s little one now.
            </li>
            <li>
              <strong>Messy Time Control:</strong> Feeding with bibs and strict
              rules. Clean-up is at Nanny’s mercy.
            </li>
            <li>
              <strong>Highchair & Feeding Sessions:</strong> Strapped in,
              spoon-fed, burped, and teased just like a real baby.
            </li>
            <li>
              <strong>Humiliation & Baby Talk:</strong> Silly nicknames, public
              baby talk, and verbal reminders of your baby role.
            </li>
            <li>
              <strong>Punishment & Correction:</strong> Spankings, corner time,
              and strict discipline for misbehavior.
            </li>
          </ul>

          <ul className='grid gap-4 text-center pl-6 mt-12'>
            <li>
              <strong>Naptime Discipline</strong>
            </li>
            <li>
              <strong>Nappy Diaper Domination</strong>
            </li>
            <li>
              <strong>Messy Time Control</strong>
            </li>
            <li>
              <strong>Highchair & Feeding Sessions</strong>
            </li>
            <li>
              <strong>Humiliation & Baby Talk</strong>
            </li>
            <li>
              <strong>Punishment & Correction</strong>
            </li>
          </ul>
          <p className='text-center text-lg italic text-colour6 pt-4'>
            If something you desire is not listed—<strong>just ask</strong>.
          </p>
        </div>
      </section>

      {/* Cta */}
      <CallToActionOne />

      {/* Form section */}
      <section className='grid w-full'>
        <div className='grid w-full px-6 lg:container lg:mx-auto gap-8 pt-12'>
          <SmallGalleryBabyComponent />
        </div>
      </section>
    </main>
  );
}

export default BabyServicesPageMainContainer;
